import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  `,
  label: css`
    color: ${colors.charcoal};
  `,
  container: css`
    &.MuiFormControl-root {
      & .MuiInputLabel-root {
        color: ${colors.charcoal};
      }
      & .MuiInput-underline:before {
        border-bottom-color: ${colors.charcoal} !important;
      }
      & .MuiInput-underline:after {
        border-bottom: 2px solid ${colors.prussian} !important;
      }
    }
  `,
  required: css`
    &.MuiFormControl-root {
      & .MuiInputLabel-root .MuiInputLabel-asterisk {
        color: ${colors.dragon} !important;
      }
    }
  `,
  containerError: css`
    &.MuiFormControl-root {
      & .MuiInput-underline:before,
      & .MuiInput-underline:after {
        border-bottom: 1px solid ${colors.dragon} !important;
      }
    }
  `,
  optionItem: css`
    display: flex !important;
    align-items: center;
    gap: 8px;
    padding: 8px 16px !important;
    cursor: pointer;
    font-size: 14px !important;
    font-family: 'Montserrat Regular';
    &:hover:not(.Mui-focusVisible) {
      background-color: #f7f7f7 !important;
    }

    &.MuiMenuItem-root.Mui-focusVisible {
      background-color: ${colors.prussian100} !important;
      box-shadow: 0 0 0 1px ${colors.white} inset, 0 0 0 3px ${colors.focusOutlineColor} inset;
    }

    &.Mui-selected {
      background-color: ${colors.platinum} !important;
      border-left: 3px solid ${colors.jungle};
      padding-left: 14px !important;
      font-family: 'Montserrat Bold';
      font-weight: bold;
      font-size: 14px;
    }

    &.Mui-selected:hover:not(.Mui-focusVisible) {
      background-color: #f7f7f7 !important;
    }
  `,
  errorMessage: css`
    font-family: 'Montserrat Regular', sans-serif;
    font-size: 0.75rem;
    line-height: 1.33;
    letter-spacing: -0.3px;
    color: ${colors.dragon};
    margin-top: 4px;
  `,
};

export default styles;
